'use client';

/**
 * ShareYarnSheet — shares a yarn via a short URL by building a
 * `.kyarn` bundle. Stock counts are stripped on the sender side so
 * "how many I own" stays private; the recipient lands in Inspiration
 * as a read-only reference card, never in their yarn library.
 *
 * Thin wrapper around the shared <ShareSheet>; the only yarn-specific
 * piece is the bundle builder.
 */

import ShareSheet from './ShareSheet';
import { buildYarnBundle } from '@/lib/yarnShare';
import { encryptAndUploadShare } from '@/lib/shareLink';
import { useI18n } from '@/lib/i18n';

interface ShareYarnSheetProps {
  yarnId: number;
  yarnLabel: string;
  open: boolean;
  onClose: () => void;
}

export default function ShareYarnSheet({ yarnId, yarnLabel, open, onClose }: ShareYarnSheetProps) {
  const { t } = useI18n();

  const onGenerate = async () => {
    const senderName = (typeof window !== 'undefined' ? (localStorage.getItem('knitter-name') || '') : '').trim() || undefined;
    const bundle = await buildYarnBundle(yarnId, { senderName });
    return encryptAndUploadShare(bundle);
  };

  return (
    <ShareSheet
      open={open}
      onClose={onClose}
      title={t.shareYarn}
      explain={t.shareYarnExplain}
      shareName={yarnLabel}
      onGenerate={onGenerate}
    />
  );
}
